import React, { useState } from 'react';
import * as Icons from '@seismic/icons';
import Truncate from 'react-truncate';
import '../style/style.scss';
import noThumbnail from '../resources/noThumbnail.png';
import { getImageUrl, UXContextType, getFormatIcon, isMobileDevice, getCurrentManifest } from '../commonUtil/util';
import { withLinkStore } from '../app/reducers';
import ActionIcon from './common/actionIcon';
import NewContentChip from './common/newContentChip';
import { KeyBoardAction } from '../commonUtil/constants';

const DocumentCard = (props) => {
    const { content } = props;
    const { id, format, name, isShowNewChip } = content || {};
    const [iconVisible, setIconVisible] = useState(false);

    const { linkBasicInfo, selectedContent, viewerSetting, manifests, contentCovers, downloadAssets } = props.linkStore;
    const cover = contentCovers.find(cc => cc.id === id).cover;
    const { canDownload, downloadFormats, enableLiveSendDownloadOptions } = linkBasicInfo;
    const currentManifest = manifests.length > 0 && getCurrentManifest(manifests.find(mf => mf.Id === id).OriginalManifests);

    const onClick = () => {
        props.onClick(content);
    };

    const handleOnKeydown = (e) => {
        if (e.keyCode === KeyBoardAction.enter) {
            props.onClick(content);
        }
    };

    const renderCustomIcon = (style) => {
        if (isMobileDevice.any()) {
            return (<Icons.CaretRightIcon style={style} />);
        }

        return null;
    };

    const onImageLoaded = () => {
        setIconVisible(true);
    };

    return (
        <div key={`${id}_${name}_${format}`}
            data-contentid={id}
            onClick={onClick}
            onKeyDown={handleOnKeydown}
            tabIndex="0"
            role="option"
            aria-selected={String(id === selectedContent.id)}
            aria-controls="playerContainer"
            className={`livesend-viewer-panel-document-card ${id === selectedContent.id ? 'selected' : ''}`}
            style={id === selectedContent.id ? { borderColor: viewerSetting.brandingHilightColor } : {}}>
            <NewContentChip brandingHilightColor={viewerSetting.brandingHilightColor} isShowNewChip={isShowNewChip} />
            <div className="document-thumbnail">
                <img aria-hidden="true" src={cover || getImageUrl(noThumbnail)} alt="document-thumbnail" onLoad={onImageLoaded} />
            </div>
            <div className="document-infos">
                <img className="format-icon"
                    alt={`${format} File Type`}
                    src={getFormatIcon(format, currentManifest.Url)} />
                <div className="document-title"><Truncate lines={name.indexOf(' ') >= 0 ? 2 : 1}> {name} </Truncate></div>
                <ActionIcon className={`common-icon ${iconVisible ? '' : 'hide'}`}
                    contextType={UXContextType.VIEWER_PANEL}
                    canDownload={canDownload}
                    content={content}
                    currentManifest={currentManifest}
                    brandingHilightColor={viewerSetting.brandingHilightColor}
                    renderCustomIcon={renderCustomIcon}
                    downloadFormats={downloadFormats}
                    downloadAssets={downloadAssets}
                    enableLiveSendDownloadOptions={enableLiveSendDownloadOptions}
                />
            </div>
        </div>
    );
};

export default withLinkStore(DocumentCard);
